
import { DatePicker, Form, Select } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { OnboardingStepProps } from "..";
import { DateFormat } from "../../../../constants/constants";
import { InfoCircleIcon } from "../../../atoms/icon";

const ReminderPeriodValues = [
    30, 60, 90
]

const { Option } = Select;


export default function CorporateInformation(props: OnboardingStepProps) {
    const { t } = useTranslation();

    return (
        <div className="section-wrapper">

            <Form.Item
                label={t("Onboarding.lbNextYearEndDate")}
                tooltip={{ title: t("Onboarding.lbNextYearEndDate"), icon: <InfoCircleIcon /> }}
                rules={[{ required: true }]}
                name="next_year_end_date"
            >
                <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
            </Form.Item>

            <Form.Item
                label={t("Onboarding.lbYearEndReminderPeriod")}
                tooltip={{ title: t("Onboarding.lbYearEndReminderPeriod"), icon: <InfoCircleIcon /> }}
                rules={[{ required: true }]}
                name="year_end_reminder_period"
            >
                <Select allowClear>
                    {
                        ReminderPeriodValues.map(item => (
                            <Option value={item} key={item}>
                                {item}
                            </Option>
                        ))
                    }
                </Select>
            </Form.Item>

            <Form.Item
                label={t("Onboarding.lbNextQuarterEndDate")}
                tooltip={{ title: t("Onboarding.lbNextQuarterEndDate"), icon: <InfoCircleIcon /> }}
                rules={[{ required: true }]}
                name="next_quarter_end_date"
            >
                <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
            </Form.Item>

            <Form.Item
                label={t("Onboarding.lbQuarterEndReminderPeriod")}
                tooltip={{ title: t("Onboarding.lbQuarterEndReminderPeriod"), icon: <InfoCircleIcon /> }}
                rules={[{ required: true }]}
                name="quarter_end_reminder_period"
            >
                <Select allowClear>
                    {
                        ReminderPeriodValues.map(item => (
                            <Option value={item} key={item}>
                                {item}
                            </Option>
                        ))
                    }
                </Select>
            </Form.Item>

            {/* <Form.Item
                    label={t("Onboarding.lbSelectConfidenceInterval")}
                    tooltip={{ title: t("Onboarding.lbSelectConfidenceInterval"), icon: <InfoCircleIcon /> }}
                >
                    <Select placeholder={t("Global.plPleaseSelect")}>

                    </Select>
                </Form.Item> */}

        </div>
    )
}